<div class="fixed left-0 right-0 bottom-0 z-2">
  <!-- <app-multiple-tabs></app-multiple-tabs> -->
  <app-cookies-popup *ngIf="isCookiePopupEnabled" [textWithLink]="textWithLink"></app-cookies-popup>
</div>
